import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import CustomTable from 'components/shared/CustomTable';

import {
  getAletsData,
  getPagination,
  setAletsData,
  setPagination,
} from 'store/alerts';

import AlertsTableRow from './AlertsTableRow';

import { headerRows } from './headerRows';

const AlertsTable = () => {
  const aletsData = useSelector(getAletsData);
  const pagination = useSelector(getPagination);
  const dispatch = useDispatch();

  const handleClick = (
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    index: number,
  ) => {
    const newRows = aletsData.map((row, indexRow) => {
      if (indexRow === index) {
        return {
          ...row,
          isSelected: !row.isSelected,
          viewed: true,
        };
      }
      return row;
    });
    dispatch(setAletsData(newRows));
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    dispatch(setPagination({ ...pagination, page: newPage }));
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<any>) => {
    dispatch(
      setPagination({ ...pagination, page: 0, pageSize: +event.target.value }),
    );
  };

  return (
    <>
      <CustomTable
        rows={aletsData}
        columns={headerRows}
        height={'calc(100vh - 280px)'}
        pagination={{ ...pagination, count: aletsData.length }}
        messageNoResult={'NO HAY ALERTAS PARA MOSTRAR'}
        renderRow={(row, index) => (
          <AlertsTableRow row={row} index={index} handleClick={handleClick} />
        )}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
};

export default AlertsTable;
